import {
  DriverStatus,
  RoleEnum,
} from "@project-management-system/shared-models";
import {
  Entity,
  PrimaryGeneratedColumn,
  Column,
  CreateDateColumn,
  UpdateDateColumn,
  VersionColumn,
} from "typeorm";

@Entity("driver")
export class DriverEntity {
  @PrimaryGeneratedColumn("increment", {
    name: "id",
  })
  id: number;

  @Column("varchar", {
    name: "name",
    length: 50,
  })
  name: string;

  @Column("varchar", {
    name: "last_name",
    length: 50,
    nullable:true
  })
  lastName: string;

  @Column("date", {
    name: "date_of_birth",
    nullable:true

  })
  dateOfBirth: Date;

  @Column("varchar", {
    name: "profile_image",
    nullable:true

  })
  profileImage: string;

  // @Column("varchar", {
  //   name: "file",
  // })
  // file: string;

  // @Column("varchar", {
  //   name: "fileList",
  // })
  // fileList: string;

  @Column("varchar", {
    name: "profile_image_path",
    nullable:true

  })
  profileImagePath: string;

  @Column("varchar", {
    name: "email",
    length: 50,
  })
  email: string;

  @Column("varchar", {
    name: "phone_number",
  })
  phoneNumber: string;

  @Column("varchar", {
    name: "address",
    nullable:true

  })
  address: Text;

  @Column("varchar", {
    name: "state",
    nullable:true,
    length: 50,
  })
  state: string;

  @Column("varchar", {
    name: "city",
    nullable:true,
    length: 50,
  })
  city: string;

  @Column("varchar", {
    name: "user_type",
  })
  userType: string;

  @Column("varchar", {
    name: "licence_number",
    nullable:true,
    length: 50,
  })
  licenceNumber: string;

  @Column("varchar", {
    name: "licence_class",
    length: 50,
    nullable:true
  })
  licenceClass: string;

  @Column("varchar", {
    name: "licence_state",
    length: 50,
    nullable:true
  })
  licenceState: string;

  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active",
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime",
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "created_user",
  })
  createdUser: string | null;

  @UpdateDateColumn({
    name: "updated_at",
    type: "datetime",
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user",
  })
  updatedUser: string | null;

  @VersionColumn({
    default: 1,
    name: "version_flag",
  })
  versionFlag: number;

  @Column("enum", {
    name: "status",
    enum: RoleEnum,
  })
  status: RoleEnum;

  @Column("enum", {
    name: "driver_status",
    enum: DriverStatus,
  })
  driverStatus: DriverStatus;

  @Column('int', {
    name: 'vendor_id',
    nullable: true
})
vendorId: number;

@Column('enum', {
  name: 'driver_type',
  nullable: false,
  enum: DriverStatus,
})
driverType: string;

@Column('date', {
  name: 'licence_expiry_date',
  nullable: false
})
licenceExpirydate: any;
}


